import { createDataHooks } from '@wix/premium-fed-sdk/test-utils';
export const SearchedDomainBrokerDataHooks = createDataHooks('searched-domain-broker', 'domain', 'feePrice', 'hireBrokerButton', 'howItWorks');
//# sourceMappingURL=dataHooks.js.map